import React from 'react';
import { useTranslation } from 'react-i18next';

function Contraintes() {
  const { t } = useTranslation();
  return <div>{t('common.constraints')}</div>;
}

export default Contraintes;
